import Api from '@/axios'

export default {
    addFeedBacks(payload) {
        return Api().post('supports', payload)
    },
    editFeedBacks(id, payload) {
        return Api().put(`supports/${id}`, payload)
    }
}